import {
  BodyHeavy,
  Carousel,
  Icon,
  MediaQuery,
  Skeleton,
  Tag,
  TextSkeleton,
  Theme,
} from '@pelando/components';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-area: alerts;
  padding: 16px 0;
  background-color: rgb(${Theme.colors.India});
  border: 1px solid rgb(${Theme.colors.Brand});
  border-radius: 16px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  margin-bottom: 8px;
  padding: 0 16px;
  color: rgb(${Theme.colors.Brand});

  ${BodyHeavy};

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-bottom: 12px;
    padding: 0 32px;
  }
`;

export const AlertTag = styled(Tag)`
  background-color: rgb(${Theme.colors.Mike});

  white-space: nowrap;

  :not(:last-child) {
    margin-right: 8px;
  }
`;

export const FlagIcon = styled(Icon)`
  color: rgb(${Theme.colors.Brand});
  font-size: 24px;
`;

export const CustomCarouselList = styled(Carousel.List)`
  && {
    overflow-x: auto;
    padding: 0 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    @media ${MediaQuery.SCREEN_MD_UP} {
      padding: 0 32px;
    }
  }
`;

export const TitleSkeleton = styled(TextSkeleton)`
  height: 20px;
  width: 100%;
  max-width: 256px;
  margin: 0 16px 8px 16px;

  @media ${MediaQuery.SCREEN_LG_UP} {
    margin: 0 32px 12px 32px;
    max-width: 408px;
  }
`;

export const AlertsSuggestionsListSkeleton = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin: 0 16px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin: 0 32px;
  }
`;

export const AlertTagSkeleton = styled(Skeleton)`
  min-width: 124px;
  max-width: 124px;
  min-height: 32px;
  max-height: 32px;
  border-radius: 8px 64px 64px 8px;
`;

const arrowStyle = css`
  color: rgb(${Theme.colors.India});
`;

export const PrevArrow = styled(Carousel.PrevIndicator)`
  ${arrowStyle}
`;
export const NextArrow = styled(Carousel.NextIndicator)`
  ${arrowStyle}
`;
